import { Container, Typography, Box, Divider } from '@mui/material';

const TermsOfService = () => {
  return (
    <Container
      maxWidth='md'
      sx={{
        lineHeight: 1.3,
      }}
    >
      {/* Header */}
      <Typography
        variant='h4'
        gutterBottom
        sx={{ fontWeight: 'medium', color: '#181436', fontSize: { xs: '1.8rem', md: '2.5rem' } }}
      >
        SINGLE COMBO LLC
      </Typography>
      <Typography variant='subtitle1' gutterBottom sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
        Consumer Terms and Conditions & Privacy Policy
      </Typography>
      <Typography variant='body2' color='text.secondary' gutterBottom>
        Effective Date: June 2, 2026
      </Typography>
      <Divider sx={{ my: { xs: 2, md: 3 } }} />
      {/* Terms and Conditions */}
      PLEASE READ THESE CONSUMER TERMS AND CONDITIONS CAREFULLY. THESE CONSUMER TERMS AND CONDITIONS
      (“AGREEMENT,” “TERMS AND CONDITIONS,” or “TERMS”) CONSTITUTE A LEGAL AGREEMENT BETWEEN YOU AND
      SINGLECOMBO, AS DEFINED BELOW.
      <Typography
        variant='h5'
        sx={{ fontWeight: 'bold', mt: { xs: 3, md: 4 }, fontSize: { xs: '1.3rem', md: '1.7rem' } }}
      >
        Terms and Conditions
      </Typography>
      <Box sx={{ mt: 2 }}>
        {[
          {
            title: '1. Eligibility',
            content:
              'You must be at least 18 years old to use our Services. By using our Services, you confirm you can legally enter into a binding agreement in your jurisdiction.',
          },
          {
            title: '2. Our Role',
            content:
              'SingleCombo provides an online marketplace connecting customers with restaurants, kitchens, and independent delivery partners (“Contractors”). We do not prepare food ourselves (except in certain cases where SingleCombo Kitchens operate) and are not responsible for the quality or safety of meals provided by restaurants or other merchants (“Merchants”).',
          },
          {
            title: '3. User Accounts',
            content:
              'You must provide accurate and up‑to‑date information when registering. You are responsible for all activity on your account and agree to keep your login details secure. Notify us immediately if you suspect unauthorized use.',
          },
          {
            title: '4. Orders & Payments',
            content:
              'Prices shown in the app or website may differ from in-store prices. You agree to pay all charges, including delivery fees, service fees, taxes, and tips. Charges are final once an order is confirmed and delivered. Refunds are at our discretion unless required by law.',
          },
          {
            title: '5. Meal Plan Membership',
            content:
              'SingleCombo offers a membership program with benefits such as reduced fees, free or discounted deliveries, or exclusive promotions. Memberships renew automatically until canceled. Membership fees are non-refundable except where required by law.',
          },
          {
            title: '6. Cancellations & Refunds',
            content:
              'Once an order is placed, it cannot be canceled if the Merchant has already started preparing it. Refunds or credits may be issued at our discretion in cases such as missing or incorrect items.',
          },
          {
            title: '7. Rules of Use',
            content:
              'You agree not to misuse our Services, engage in fraudulent activity, share accounts, harass others, or interfere with the platform’s operation.',
          },
          {
            title: '8. Communications',
            content:
              'By using the Services, you agree to receive order updates, service announcements, and promotional offers. You may opt out of marketing communications but transactional updates (like delivery status) are required.',
          },
          {
            title: '9. Intellectual Property',
            content:
              'All content, logos, and technology used in the Services belong to SingleCombo or its partners. You may not copy or use them without permission.',
          },
          {
            title: '10. Limitation of Liability',
            content:
              'To the maximum extent permitted by law, SingleCombo’ liability is limited to the amount you paid for the order giving rise to the claim.',
          },
          {
            title: '11. Dispute Resolution',
            content:
              'Any disputes will first be attempted to resolve through our customer support team. If not resolved, disputes may be subject to binding arbitration or small claims court where permitted.',
          },
          {
            title: '12. Termination',
            content:
              'We may suspend or terminate your account if you violate these Terms or engage in fraudulent or abusive conduct.',
          },
          {
            title: '13. Contact Us',
            content:
              'SingleCombo Customer Support\nEmail: info@singlecombo.com, \n \n Address: 4556 Oakton, Skokie, IL 60077',
          },
        ].map((section, index) => (
          <Box key={index} sx={{ mb: { xs: 3, md: 4 } }}>
            <Typography
              variant='h6'
              gutterBottom
              sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.2rem' } }}
            >
              {section.title}
            </Typography>
            <Typography paragraph sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
              {section.content}
            </Typography>
          </Box>
        ))}
      </Box>
      <Divider sx={{ my: { xs: 2, md: 3 } }} />
      <div style={{ height: '100px', color: 'white' }}>Empty space for mobile</div>
    </Container>
  );
};

export default TermsOfService;
